import coreStore from '@/stores/core';
import { dispatchTrack } from '@/utils/tracking';
import { TRACKING_OPERATION, TRACKING_PAGE, TRACKING_SECTION } from '@/utils/tracking/constants';
import { getHeaders } from '@/services/request';
import { TrackingType } from '../types';

export const getNoticeTrackParams = ({
  page = TRACKING_PAGE.CS_CHAT_APP,
  trackingname = '',
  data,
}: TrackingType) => {
  const { accountType } = getHeaders();
  return {
    page,
    trackingname,
    data: {
      chat_id: `${coreStore.safeGetStore('agentStore').sessionID}`,
      business_user_id: coreStore.safeGetStore('userStore').userId,
      business_user_account_type: accountType,
      ...(data || {}),
    },
  };
};

const trackNotice = ({
  page,
  trackingname = '',
  operation = TRACKING_OPERATION.CLICK,
  data,
}: TrackingType) => {
  const { data: formatData } = getNoticeTrackParams({ page, trackingname, data });
  dispatchTrack({
    page,
    section: TRACKING_SECTION[trackingname as (keyof typeof TRACKING_SECTION)],
    operation,
    data: formatData,
  });
};


export default trackNotice;
